module.exports = __webpack_public_path__ + "static/media/nima_walk_from_flash.03f59c5b.gif";